// extracted by mini-css-extract-plugin
export default {"element":"accordion_element__zmFBx","content":"accordion_content__b+RsJ","left_side":"accordion_left_side__Fi4nr"};